'use client';

import { NativeSelect, NativeSelectOption } from '@svenskaspelab/ui/react/select';
import type { ReactNode } from 'react';

import { getFormattedCurrency } from '../../core/lib/entry.browser.js';

type CouponAdditionsCommissionSelectorProps = {
  commissionValueOptions: number[];
  onValueChange: (value: number) => void;
  selectedCommissionPercent: number;
  commissionPercent: number;
};

/**
 * Component responsible for rendering the commission selector in the coupon additions.
 *
 * @param root0 props
 * @param root0.commissionValueOptions list of commission value options
 * @param root0.onValueChange callback for when the selected commission changes
 * @param root0.selectedCommissionPercent the currently selected commission percentage
 * @param root0.commissionPercent the commission percent for the activated draw, used to determine if some options should be disabled
 * @returns renders the commission selector
 */
export function CouponAdditionsCommissionSelector({
  commissionValueOptions,
  onValueChange,
  selectedCommissionPercent,
  commissionPercent,
}: CouponAdditionsCommissionSelectorProps): ReactNode {
  const selectedValue = `${selectedCommissionPercent}`;

  return (
    <div className="flex">
      <NativeSelect
        value={selectedValue}
        aria-label="Välj avgift"
        aria-invalid={false}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
          const { value } = e.target;
          onValueChange(Number.parseInt(value, 10));
        }}
      >
        {commissionValueOptions.map((commissionValue, index) => {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <NativeSelectOption key={`commission-${index}`} value={`${index}`} disabled={index > commissionPercent}>
              {index}% (Spelpott: {getFormattedCurrency(commissionValue, { shouldUseDecimals: true })})
            </NativeSelectOption>
          );
        })}
      </NativeSelect>
    </div>
  );
}
